import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { deleteUseCase } from "../api/use-cases-api"

export function useDeleteUseCase() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteUseCase(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
    },
  })
}
